var AppModule = (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };



// WEBPACK FOOTER //
// /opt/app/src/app/app.module.ts.pre-build-optimizer.js